import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { ShimmerPlaceHolder } from "@faire/retailer-visitor-shared/components/Animation/ShimmerPlaceHolder";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import styled from "styled-components";
export var SuppliersPageHeaderLoadingSkeleton = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        "data-test-id": "header-placeholder",
        children: [
            /*#__PURE__*/ _jsxs(Row, {
                children: [
                    /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                        $width: 120,
                        $height: 20
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Chevron, {
                        direction: "right",
                        fontSize: "14px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        width: "1x"
                    }),
                    /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                        $width: 120,
                        $height: 20
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "1x"
            }),
            /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                $height: 36,
                $width: 264
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 10
            }),
            /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                $height: 36,
                $width: 216
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "3x"
            }),
            /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                $height: 16,
                $width: 288
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: 10
            }),
            /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                $height: 16,
                $width: 232
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "4x"
            }),
            /*#__PURE__*/ _jsx(StyledPlaceHolder, {
                $height: 16,
                $width: 168
            })
        ]
    });
};
var StyledPlaceHolder = styled(ShimmerPlaceHolder).withConfig({
    componentId: "sc-5461571a-0"
})([
    "background-color:",
    ";"
], Core.surface.inverse);
